export const IDENTIFICADA_TRACKING = {
    productAreaOrigin: 'Home',
    status: 'Identificado',
    timeResponsavel: 'Sky',
} as const;

export const IDENTIFICADA_STEP = {
    cadastroNaoIniciado: 'Cadastro não iniciado',
    cadastroPendente: 'Cadastro pendente',
    dadosEmAnalise: 'Dados em análise',
    envioDocumentos: 'Envio de documentos',
    documentosEmAnalise: 'Documentos em análise',
    pendenciaExterna: 'Pendência externa',
} as const;

export const IDENTIFICADA_STEP_LABEL: Record<string, string> = {
    [IDENTIFICADA_STEP.cadastroNaoIniciado]: 'Não se aplica',
    [IDENTIFICADA_STEP.cadastroPendente]: 'Termine seu cadastro',
    [IDENTIFICADA_STEP.dadosEmAnalise]: 'Estamos validando seus dados',
    [IDENTIFICADA_STEP.envioDocumentos]: 'Envie a foto dos seus documentos',
    [IDENTIFICADA_STEP.documentosEmAnalise]: 'Estamos validando seus documentos',
    [IDENTIFICADA_STEP.pendenciaExterna]: 'Não se aplica',
};
